var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "contentalignstart",
        class: { sennoTitleActive: !_vm.coverInfo.logo }
      },
      [
        _vm.coverInfo.logo
          ? _c("div", { staticClass: "imgBorder" }, [
              _c("img", {
                staticClass: "companyLogo",
                attrs: {
                  align: "middle",
                  src: "data:image/*;base64," + _vm.coverInfo.logo + ""
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0)
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt300" }, [
      _c(
        "div",
        {
          staticClass:
            "content-row content-row-column auto-width font-26 margin_left",
          staticStyle: { "margin-left": "40%", color: "#fff" }
        },
        [
          _c(
            "span",
            {
              staticClass: "big_font",
              staticStyle: { "letter-spacing": ".1rem" }
            },
            [_vm._v(_vm._s(_vm.$t("indexPage.a_posture_title")))]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "margin-top-80", attrs: { id: "ul_list" } }, [
      _c(
        "div",
        {
          staticClass:
            "content-row content-row-column auto-width font-16 cover-text margin_left small_font",
          staticStyle: {
            "margin-left": "40%",
            color: "#fff",
            "line-height": "1.5rem"
          }
        },
        [
          _c(
            "p",
            { staticStyle: { display: "flex", "align-item": "center" } },
            [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "7.2rem" } },
                [_vm._v(_vm._s(_vm.$t("coverInfo.customerName")) + "：")]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.coverInfo.customerName))])
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { display: "flex", "align-item": "center" } },
            [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "7.2rem" } },
                [_vm._v(_vm._s(_vm.$t("coverInfo.date")) + "：")]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.coverInfo.date))])
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { display: "flex", "align-item": "center" } },
            [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "7.2rem" } },
                [_vm._v(_vm._s(_vm.$t("coverInfo.time")) + "：")]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.coverInfo.time))])
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { display: "flex", "align-item": "center" } },
            [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "7.2rem" } },
                [_vm._v(_vm._s(_vm.$t("coverInfo.userName")) + "：")]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.coverInfo.userName))])
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cover-btn", on: { click: _vm.slideIn } }, [
      _c("span", { staticClass: "doublearrortop" }, [
        _vm._v(_vm._s(_vm.$t("coverInfo.clickEnterReport")))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "doublearrorbottom" })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sennoTitle" }, [
      _vm._v("\n      Powered By\n      "),
      _c("div", { staticClass: "senno-logo" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9dea9b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9dea9b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_home.vue
// module id = null
// module chunks = 